import { createContext, useCallback, useState, useSyncExternalStore } from "react"
import API from "services/api"
import _ from "lodash"
import toast from "react-hot-toast"

export const InvoiceContext = createContext({})

const InvoiceProvider = (props) => {
	const [invoices, setInvoices] = useState([])
	const [allinvoices, setAllInvoices] = useState([])
	const [datainvoice, setDataInvoice] = useState({})
	const [filingtoInvoices, setFilingToInvoice] = useState([])

	const [invoiceReport, setInvoiceReport] = useState([])

	const getInvoices = (params) => {
		return API.getInvoices(params)
			.then((res) => {
				const data = res.data
				setInvoices(data)
				setAllInvoices(data)
				return data
			})
			.catch((err) => {
				console.log("err", err)
				return err
			})
	}

	const getInvoiceReport = async (params) => {
		await API.getInvoiceReport(params)
			.then((res) => {
				const data = res.data
				setInvoiceReport(data)
			})
			.catch((err) => {
				toast.error("fetch report failed", err)
			})
	}

	const getInvoiceByID = (id) => {
		return API.getInvoiceByID(id)
			.then((res) => {
				const data = res.data
				setDataInvoice(data)
				return data
			})
			.catch((err) => console.log("err", err))
	}

	const getFilingbyContact = (id) => {
		return API.getFilingbyContact(id)
			.then((res) => {
				const data = res.data
				setFilingToInvoice(data)
				return data
			})
			.catch((err) => console.log("err", err))
	}

	const postInvoice = (sendData) => {
		return API.postInvoice(sendData)
			.then((res) => {
				const { data } = res
				// getInvoices()
				return data
			})
			.catch((err) => {
				return err
			})
	}

	const addTaxtoInvoiceBatch = (sendData) => {
		return API.addTaxtoInvoiceBatch(sendData)
			.then((res) => {
				const { data } = res
				return data
			})
			.catch((err) => {
				return err
			})
	}

	const generateInvoiceNumber = (sendData) => {
		return API.generateInvoiceNumber(sendData)
			.then((res) => {
				const { data } = res
				// getInvoices()
				return data
			})
			.catch((err) => {
				return err
			})
	}

	const putInvoice = (id, sendData) => {
		return API.putInvoice(id, sendData)
			.then((res) => {
				const { data } = res
				return data
			})
			.catch((err) => {
				console.log("err", err)
				return err
			})
	}

	const deleteInvoice = (id) => {
		return API.deleteInvoice(id)
			.then((res) => {
				const { data } = res

				return { status: 200, data: data?.data }
			})
			.catch((err) => {
				console.log("err", err)
				return { status: 404, data: err.message }
			})
	}

	return (
		<InvoiceContext.Provider
			value={{
				invoices,
				allinvoices,
				setInvoices,
				setAllInvoices,
				getInvoices,
				getInvoiceByID,
				postInvoice,
				addTaxtoInvoiceBatch,
				generateInvoiceNumber,
				putInvoice,
				deleteInvoice,

				invoiceReport,
				getInvoiceReport,

				filingtoInvoices,
				getFilingbyContact,

				datainvoice,
				setDataInvoice
			}}
			{...props}
		/>
	)
}

export default InvoiceProvider
